const filterAdapters = {
  business_unit: {
    field: 'wo_org_unit_name',
    path: 'work_order'
  },
  status: {
    field: 'wo_status',
    path: 'work_order'
  },
  location: {
    field: 'wo_worksite_name',
    path: 'work_order'
  },
  rm: {
    field: 'wo_resource_manager_name',
    path: 'work_order'
  },
  vendor: {
    field: 'wo_vendor_name',
    path: 'work_order'
  },
  program_team_entity: {
    field: 'program_team_entity_id',
    path: 'work_order'
  }
}

export default filterAdapters
